import "./main.pcss";
import initializeForm from "./components/form/form";
import trimOnBlur from "./components/input/trimOnBlur";
import password from "./components/input/password";

initializeForm();
trimOnBlur();
password();
